import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";

const VERIFICATION_URL = "https://api.sortyfy.com/api/eventcart/verifiedTicket";

const TicketVerification = () => {
  const { ticketId: pathTicketId } = useParams();
  const location = useLocation();
  const ticketId = pathTicketId || new URLSearchParams(location.search).get("ticketId");
  const [state, setState] = useState({ status: "loading", message: "Checking ticket…" });

  useEffect(() => {
    let active = true;

    if (!ticketId) {
      setState({ status: "invalid", message: "Ticket ID is missing." });
      return () => {
        active = false;
      };
    }

    setState({ status: "loading", message: "Checking ticket…" });
    axios
      .post(VERIFICATION_URL, { ticketId })
      .then(({ data }) => {
        if (!active) return;
        const isValid =
          data?.status === "success" ||
          data?.status === true ||
          data?.valid === true ||
          data?.isValid === true;
        const isInvalid =
          data?.status === "failed" ||
          data?.status === "invalid" ||
          data?.status === false ||
          data?.valid === false ||
          data?.isValid === false;

        if (isValid) {
          setState({ status: "valid", message: data?.message || "This ticket is valid." });
        } else if (isInvalid) {
          setState({ status: "invalid", message: data?.message || "This ticket is invalid." });
        } else {
          setState({ status: "error", message: "We couldn’t confirm this ticket. Please try again." });
        }
      })
      .catch((error) => {
        if (!active) return;
        const data = error?.response?.data;
        const explicitlyInvalid =
          data?.status === "failed" ||
          data?.status === "invalid" ||
          data?.status === false ||
          data?.valid === false ||
          data?.isValid === false;
        setState(
          explicitlyInvalid
            ? { status: "invalid", message: data?.message || "This ticket is invalid." }
            : { status: "error", message: "Ticket verification failed. Please try again." }
        );
      });

    return () => {
      active = false;
    };
  }, [ticketId]);

  const colors = {
    loading: "#475569",
    valid: "#15803d",
    invalid: "#b91c1c",
    error: "#b45309",
  };

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: "#f1f5f9",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <section
        aria-live="polite"
        style={{
          width: "100%",
          maxWidth: 440,
          padding: "40px 32px",
          textAlign: "center",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 8px 30px rgba(15, 23, 42, 0.1)",
        }}
      >
        <div style={{ color: colors[state.status], fontSize: 48, lineHeight: 1 }} aria-hidden="true">
          {state.status === "loading" ? "…" : state.status === "valid" ? "✓" : state.status === "invalid" ? "×" : "!"}
        </div>
        <h1 style={{ margin: "18px 0 8px", fontSize: 24, color: "#0f172a" }}>
          {state.status === "loading"
            ? "Verifying ticket"
            : state.status === "valid"
            ? "Valid ticket"
            : state.status === "invalid"
            ? "Invalid ticket"
            : "Unable to verify"}
        </h1>
        <p style={{ margin: 0, color: colors[state.status], fontSize: 16 }}>{state.message}</p>
      </section>
    </main>
  );
};

export default TicketVerification;
